import { render } from "./VideoList.vue?vue&type=template&id=112c44c4&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"

import "./VideoList.vue?vue&type=style&index=0&id=112c44c4&scoped=true&lang=css"
import "./video-gallery.css?vue&type=style&index=1&id=112c44c4&scoped=true&lang=css&external"
import "./VideoList.vue?vue&type=style&index=2&id=112c44c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112c44c4"]])

export default __exports__